import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./deviceSection.css"

const DeviceSectionImage = ({ customStyle, imageAlt, srcSet }) => (
  <div className={classnames(styles.panel, styles.panelImage, customStyle)}>
    <div className={classnames(styles.image)}>
      <img loading="lazy" src={srcSet[0]} srcSet={`${srcSet[0]} 1x, ${srcSet[1]}`} alt={imageAlt} />
    </div>
  </div>
)

DeviceSectionImage.propTypes = {
  customStyle: PropTypes.string,
  imageAlt: PropTypes.string,
  srcSet: PropTypes.array.isRequired,
}

export default DeviceSectionImage
